<template lang="pug">
  multiselect(
    :value="value"
    :options="businessList"
    placeholder="Type to search",
    label="business_name"
    track-by="business_name"
    name="id"
    @input="onInput"
    :disabled="disabled"
    :loading="business_loading"
    :internalSearch="false"
    @search-change="loadBusiness"
  )
    template(slot="option" slot-scope="props")
      span.block {{ props.option.business_name }}
</template>

<script>
import business from '@js/store/modules/business';

export default {
    props: {
        value: {
            type: null,
            default: () => null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            businessList: [],
            business_loading: false,
        };
    },
    beforeCreate() {
        if (!this.$store.hasModule('business')) {
            this.$store.registerModule('business', business);
        }
    },
    mounted() {
        this.loadBusiness();
    },

    methods: {
        onInput(value) {
            this.$emit('input', value);
        },

        loadBusiness: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.business');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };
            this.business_loading = true;
            return axios
                .get(api, options)
                .then(res => {
                    this.businessList = res.data.data;
                    this.business_loading = false;
                })
                .catch(err => {
                    throw err;
                });
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/BusinessSelector.vue